/* eslint-disable react/jsx-props-no-spreading */
/**
 * @author Shalini Jha
 * @name QuickTour
 * @desc This component allows users to create quick tutorials for any component
 * React-Joyride is used to implement this
 */

import React from 'react';
import PropTypes from 'prop-types';
import Joyride, { STATUS } from 'react-joyride';
import Tooltip from './Tooltip';
import { Services, AppUtils } from '@gscope-mfe/app-bridge';
const { getQuickTourInfo } = Services;
export const handleQuickTour = ({ status }, setStartQuickTour) => {
    if (status === STATUS.FINISHED) {
        setStartQuickTour(false);
    }
    return null;
};
const QuickTour = ({ pathname, setStartQuickTour, startQuickTour }) => {
    const [quickTourSteps, setQuickTourSteps] = React.useState([]);
    const { currentMarket, userInfo } = AppUtils.get();

    /**
     * @name getTourSteps
     * @desc Fetches the config for quick tour from CCM
     * Saves it to the state variable
     */

    const getTourSteps = async () => {
        try {
            const { data } = await await getQuickTourInfo(
                window.location.pathname,
                currentMarket,
                userInfo.username,
                'quickTutorial',
            );
            const quickTutorialData = JSON.parse(data.payload.quickTutorial);
            if (quickTutorialData[pathname] !== undefined && quickTutorialData[pathname].length > 0) {
                quickTutorialData[pathname][0].disableBeacon = true;
                setQuickTourSteps(quickTutorialData[pathname]);
            }
        } catch (error) {
            console.log(error);
        }
    };
    React.useEffect(() => {
        getTourSteps();
    }, []);
    return (
        <>
            {quickTourSteps.length > 0 && (
                <Joyride
                    callback={(data) => handleQuickTour(data, setStartQuickTour)}
                    steps={quickTourSteps}
                    continuous
                    run={startQuickTour}
                    tooltipComponent={(props) => <Tooltip {...props} allSteps={quickTourSteps} />}
                    styles={{
                        options: {
                            zIndex: 1500,
                            maxWidth: 220,
                        },
                    }}
                />
            )}
        </>
    );
};
QuickTour.propTypes = {
    pathname: PropTypes.string.isRequired,
};
export default QuickTour;
